import { paths } from "@web-monorepo/api-types";
import useMutation from "#/src/hooks/useMutation";
import { monolithApiClient } from "#/src/configs/axios.config";

type Endpoint = paths["/api/marketplace/decagon/widget-token"]["post"];
type Response = Endpoint["responses"][200]["content"]["application/json"];

const decagonAuthToken = () => monolithApiClient.post<Response>(`/decagon/widget-token`);

const useDecagonAuthTokenMutation = () => useMutation(decagonAuthToken);

export default useDecagonAuthTokenMutation;
